module.exports = __webpack_public_path__ + "media/images/facebook-2376a25f.svg";